/**
 * utils/ajax-headers.js — автоподстановка заголовков для jQuery.ajax.
 * Только jQuery (глобально). Другие файлы из utils/ не требуются.
 * Разметка: <meta name="csrf-token">, опционально <meta name="sanctum-token">.
 */
jQuery(document).ready(function () {
    let csrfToken = jQuery('meta[name="csrf-token"]').attr('content');
    let sanctumToken = jQuery('meta[name="sanctum-token"]').attr('content');

    let headers = {};

    if (csrfToken) {
        headers['X-CSRF-TOKEN'] = csrfToken;
    }

    if (sanctumToken) {
        headers['Authorization'] = 'Bearer ' + sanctumToken;
    }

    if (Object.keys(headers).length > 0) {
        jQuery.ajaxSetup({ headers });
    }
});
